// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2IrwU","select":"Header_select__k3v53","clinic":"Header_clinic__1imlJ"};